/* eslint-disable no-restricted-imports */
import queryString from 'query-string';

export const getRawQueryString = () => location.search;

export const getQueryParams = (search) =>
  queryString.parse(search);

